import { __rest } from 'tslib';
import React from 'react';
import { ChevronLeft } from '../../icons/ChevronLeft/ChevronLeft.js';
import { ChevronRight } from '../../icons/ChevronRight/ChevronRight.js';
import { useTheme } from '../../theme/Theme.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { useTranslation } from '../../locale/useTranslation.js';
import { Root, PaginationButton } from './styled.js';

const Pagination = (_a) => {
    var { size = 'medium', prevIconTooltip, nextIconTooltip } = _a, props = __rest(_a, ["size", "prevIconTooltip", "nextIconTooltip"]);
    const theme = useTheme();
    const t = useTranslation();
    const sizeProp = {
        medium: 'default',
        small: 'small',
    }[size];
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-pagination' }, props, { "$theme": theme, prevIcon: React.createElement(PaginationButton, { "$size": size, theme: theme },
            React.createElement(ChevronLeft, null)), nextIcon: React.createElement(PaginationButton, { "$size": size, theme: theme },
            React.createElement(ChevronRight, null)), jumpPrevIcon: React.createElement(Tooltip, Object.assign({ title: t('primitives.Pagination.prev') }, prevIconTooltip),
            React.createElement(PaginationButton, { "data-testid": 'jump-prev-icon', "$size": size, theme: theme }, "...")), jumpNextIcon: React.createElement(Tooltip, Object.assign({ title: t('primitives.Pagination.next') }, nextIconTooltip),
            React.createElement(PaginationButton, { "data-testid": 'jump-next-icon', "$size": size, theme: theme }, "...")), size: sizeProp, locale: Object.assign(Object.assign({ jump_to: t('primitives.Pagination.jumpto'), items_per_page: '' }, props.locale), { page: '' }) })));
};

export { Pagination };
//# sourceMappingURL=Pagination.js.map
